// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__1NFO9","content":"Header_content__BMsIS","dragHandle":"Header_dragHandle__1xCQD","last":"Header_last__3WPOJ","fixed":"Header_fixed__3uupg"};